module.exports = __webpack_public_path__ + "img/favicon.4aa0171f.png";